var style = {"z-fieldset":"z-fieldset"};

export { style as default };
//# sourceMappingURL=Fieldset.module.scss.js.map
